import { useState, useCallback } from 'react';

export default function useBoolean(
  initial = false
): [boolean, { toggleValue: () => void; toTrue: () => void; toFalse: () => void }] {
  const [value, setValue] = useState(initial);
  const toggleValue = useCallback(() => setValue(value => !value), []);
  const toTrue = useCallback(() => setValue(true), []);
  const toFalse = useCallback(() => setValue(false), []);

  return [
    value,
    {
      toggleValue,
      toTrue,
      toFalse
    }
  ];
}
